import moment from "moment";
import Config from "../config/main";

const timeFilters = [];
let timeZone = Config.main.changeTimeFiltersTimeZone;

for (let i = 0; i < 7; i++) {
    //TODO change filter time zone depend on county
    let from = timeZone ? moment.utc().add("day", i).utcOffset(timeZone).startOf('day').unix() : moment().add(i, "day").utcOffset("+08:00").startOf('day').unix(),
        to = timeZone ? moment.utc().add("day", i).utcOffset(timeZone).endOf('day').unix() : moment().add(i, "day").utcOffset("+08:00").endOf('day').unix(),
        name = timeZone ? moment.utc().add("day", i).utcOffset(timeZone).startOf('day').format(Config.main.asianDateFormat) : moment().add(i, "day").utcOffset("+08:00").startOf('day').format(Config.main.asianDateFormat);
    timeFilters.push({
        from,
        to,
        name
    });
}

timeFilters.push({
    from: timeZone ? moment.utc().add("day", 6).utcOffset(timeZone).endOf('day').unix() : moment().add(6, "day").utcOffset("+08:00").endOf('day').unix(),
    name: "Future games",
    to: Infinity
});

export { timeFilters };